import { useDispatch, useSelector, useStore } from 'react-redux'
import type { TypedUseSelectorHook } from 'react-redux'
import type { RootState, AppDispatch, AppStore } from './store'

//
// Use throughout your app instead of plain `useDispatch` and `useSelector`
// https://redux-toolkit.js.org/tutorials/typescript#define-root-state-and-dispatch-types

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppStore: () => AppStore = useStore;